var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobContainer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5144 0.125843C15.8164 -0.0419476 16.1836 -0.0419476 16.4856 0.125843L31.4856 8.45918C31.8031 8.63555 32 8.97017 32 9.33333V17.6667H30V9.92174L16 2.14396L2 9.92174V25.4116L16.4856 33.4592L15.5144 35.2075L0.514357 26.8742C0.196892 26.6978 0 26.3632 0 26V9.33333C0 8.97017 0.196892 8.63555 0.514357 8.45918L15.5144 0.125843Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4856 18.5408C16.1836 18.7086 15.8164 18.7086 15.5144 18.5408L0.514357 10.2075L1.48564 8.45917L16 16.5227L30.5144 8.45918L31.4856 10.2075L16.4856 18.5408Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3412 21.823L34.6569 25.5248C35.1141 25.8434 35.1141 26.4894 34.6569 26.8081L29.3412 30.5098C28.7855 30.8977 27.9998 30.5217 27.9998 29.8685V22.4651C27.9998 21.8119 28.7855 21.4359 29.3412 21.823Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3412 21.823L27.6569 25.5248C28.1141 25.8434 28.1141 26.4894 27.6569 26.8081L22.3412 30.5098C21.7855 30.8977 20.9998 30.5217 20.9998 29.8685V22.4651C20.9998 21.8119 21.7855 21.4359 22.3412 21.823Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobContainer);
export default __webpack_public_path__ + "static/media/job-container.7085b11b787a82bb20a89a235423820b.svg";
export { ForwardRef as ReactComponent };